var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('div',{staticClass:"primary-bg"}),_c('main',{directives:[{name:"trigger",rawName:"v-trigger"}]},[_c('Intro'),_c('About'),_c('Project'),_c('Resume'),_c('ResumeLink')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }